export const ColorsCell = {
  ReadOnlyBackground: "#f5f7f7",
  AutoColColor: "#7396bf",
  ErrorBackground: "#f56f79",
  WarningBackground: "#facf53",
  EditableBackground: "#fff",
  ThirtyMinuteRow: "#7396bf",
  AlgoBackground: "#efded9"
};
